/* eslint-disable eqeqeq */
import moment from 'moment-timezone';
// eslint-disable-next-line import/no-cycle
import { getValidationDate } from 'helpers/forms';
import i18n from '../../i18n';

const MIN_DATE_ANY = new Date('1990');
const MAX_DATE_ANY = new Date('2030');
const PUBLIC = 'Public';

export const PRIVATE_ID = 'private';
export const PLANNED_ID = 'planned';
export const PUBLIC_ID = 'public';
export const INCIDENT_TYPES = {
  public: {
    title: 'incident',
    type: PUBLIC
  },
  planned: {
    title: 'Scheduled maintenance',
    type: PUBLIC
  }
};

export const getBorderDates = (type, timezone, edit) => {
  let startMin;
  let startMax;
  let completeMin;
  let completeMax;

  if (type === 'planned') {
    if (edit) {
      if (edit.status === 'PL') {
        const currDate = getValidationDate(new Date(), timezone);
        const maxDate = getValidationDate(MAX_DATE_ANY, timezone);
        startMin = currDate;
        startMax = maxDate;
        completeMin = currDate;
        completeMax = maxDate;
      } else if (edit.status === 'OP') {
        const currDate = getValidationDate(new Date(), timezone);
        const minDate = getValidationDate(MIN_DATE_ANY, timezone);
        const maxDate = getValidationDate(MAX_DATE_ANY, timezone);
        startMin = minDate;
        startMax = currDate;
        completeMin = currDate;
        completeMax = maxDate;
      } else {
        const currDate = getValidationDate(new Date(), timezone);
        const minDate = getValidationDate(MIN_DATE_ANY, timezone);
        startMin = minDate;
        startMax = currDate;
        completeMin = minDate;
        completeMax = currDate;
      }
    } else {
      const currDate = getValidationDate(new Date(), timezone);
      const maxDate = getValidationDate(MAX_DATE_ANY, timezone);
      startMin = currDate;
      startMax = maxDate;
      completeMin = currDate;
      completeMax = maxDate;
    }
  } else {
    const currDate = getValidationDate(new Date(), timezone);
    const minDate = getValidationDate(MIN_DATE_ANY, timezone);
    startMin = minDate;
    startMax = currDate;
    completeMin = minDate;
    completeMax = currDate;
  }
  return {
    startMin,
    startMax,
    completeMin,
    completeMax
  };
};

export const getFieldsConfig = (
  type,
  backfill,
  privacy,
  tz,
  edit,
  incidentSources
) => {
  const isPlanned = type === 'planned';
  const { startMin, startMax, completeMin, completeMax } = getBorderDates(
    type,
    tz,
    edit
  );
  const timezone = tz || 'UTC';
  const startTime = edit
    ? edit.start_time
    : getValidationDate(new Date(), timezone);
  const endTime = edit
    ? edit.scheduled_end_time
      ? edit.scheduled_end_time
      : edit.end_time
    : // : type === 'public'
      // ? null
      getValidationDate(new Date(), timezone);
  const configObj = [
    {
      id: 'formTitle',
      name: 'formTitle',
      value: `${
        edit
          ? `${i18n.t('components.createIncident.edit')} `
          : `${i18n.t('components.createIncident.new')} `
      }${
        isPlanned
          ? i18n.t('components.createIncident.maintenance')
          : i18n.t('components.createIncident.incident')
      }`
    },
    {
      id: 'privacy',
      name: 'privacy',
      type: 'privacy',
      // disabled: edit,
      hideComponent: false
    },
    {
      id: 'name',
      name: 'name',
      label: `${isPlanned ? 'Maintenance' : 'Incident'} title`,
      required: true,
      hideLabel: true,
      placeholder: isPlanned
        ? i18n.t('components.createIncident.scheduledMaintenance')
        : i18n.t('components.createIncident.incidentTitle')
    },
    {
      id: 'description',
      name: 'description',
      hideLabel: true,
      required: true,
      label: i18n.t('components.createIncident.description'),
      placeholder: isPlanned
        ? i18n.t('components.createIncident.schedulingMaintenanceForSearch')
        : i18n.t('components.createIncident.investigatingThisIssue'),
      type: 'textarea'
    },
    {
      id: 'source',
      name: 'source',
      label: i18n.t('components.createIncident.source'),
      type: 'source',
      items: incidentSources
    },
    {
      id: 'backfill',
      name: 'backfill',
      label: i18n.t('components.createIncident.backfillIncident'),
      type: 'checkbox',
      tipTxt: i18n.t('components.createIncident.backfillIncidentTip'),
      tipPosition: 'top',
      hideComponent: isPlanned,
      disabled: edit
    },
    {
      id: 'tz-info',
      name: 'Timezone Info',
      type: 'tz-info',
      isPlanned,
      timezone
    },
    {
      id: 'start',
      name: 'start',
      label: i18n.t('components.createIncident.start'),
      type: 'datetime',
      timezone,
      currentTime:
        edit || type === 'public'
          ? startTime
          : moment
              .tz(endTime, 'UTC')
              .add(60, 'minutes')
              .format(),
      maxDate: startMax,
      minDate: startMin,
      // disabled: isCancelledSM,
      width: 1 / 2
    },
    {
      id: 'end',
      name: 'end',
      label: i18n.t('components.createIncident.completion'),
      type: 'datetime',
      timezone,
      currentTime:
        edit || type === 'public'
          ? endTime
          : moment
              .tz(endTime, 'UTC')
              .add(120, 'minutes')
              .format(),
      maxDate: completeMax,
      minDate: completeMin,
      disabled: type === 'public' && !((edit && edit.end_time) || backfill),
      width: 1 / 2
    },
    {
      id: 'duration',
      name: 'duration',
      timezone,
      type: 'duration',
      hideComponent: type !== 'planned'
    },
    {
      id: 'affected',
      name: 'affected',
      label: i18n.t('components.createIncident.affectedComponents'),
      width: 1,
      disabled: type === 'private',
      type: 'affected',
      hideComponent: edit || privacy === 'Private',
      value: edit ? edit.affected_components : [],
      isPlanned
    },
    {
      id: 'automation',
      name: 'automation',
      label: i18n.t('components.createIncident.automationSettings'),
      width: 1,
      hideComponent: !isPlanned || privacy === 'private',
      type: 'automation'
    },
    {
      id: 'notification_options',
      name: 'notification_options',
      label: i18n.t('components.createIncident.notificationOptions'),
      type: 'notification_options',
      hideComponent: backfill || privacy === 'Private',
      fields: [
        {
          id: 'email',
          name: 'send_email',
          label: i18n.t('components.createIncident.notifySubscribers'),
          width: 0.3,
          isMenu: true,
          type: 'checkbox'
        },
        {
          id: 'tweet',
          name: 'send_tweet',
          label: i18n.t('components.createIncident.tweetThis'),
          width: 0.5,
          isMenu: true,
          type: 'twitter'
        }
      ]
    }
  ].reduce(function(acc, cur) {
    acc[cur.id] = cur;
    return acc;
  }, {});
  return configObj;
};

export const getValuesFromTemplate = (template = {}) => {
  const notification_options = {};
  Object.keys(template.notification_options || {}).forEach(key => {
    notification_options[key] = template.notification_options[key] == 'true';
  });
  const values = {
    affected: template.affected_components,
    description: template.description,
    name: template.title,
    is_auto_update_status_on_end:
      template.is_planned && template.is_auto_update_status_on_scheduled_end,
    is_auto_update_status_on_start:
      template.is_planned && template.is_auto_update_status_on_scheduled_start
  };

  const filteredValues = {};
  Object.keys(values).forEach(key => {
    if (values[key]) filteredValues[key] = values[key];
  });
  return {
    ...filteredValues,
    ...notification_options,
    ...(template.privacy && { privacy: template.privacy })
  };
};
export const PRIVACY_OPTIONS = [
  {
    id: 'public',
    label: i18n.t('components.createIncident.public'),
    desc: i18n.t('components.createIncident.publicDesc')
  },
  {
    id: 'private',
    label: i18n.t('components.createIncident.private'),
    desc: i18n.t('components.createIncident.privateDesc')
  }
];
export const getDefaultIncident = (timezone, edit, type, alert) => {
  const defaultIncidentSource = null;
  const start = edit
    ? edit.start_time
      ? getValidationDate(edit.start_time, timezone)
      : getValidationDate(edit.start_time, timezone)
    : getValidationDate(new Date(), timezone);
  const end = edit
    ? edit.end_time
      ? getValidationDate(edit.end_time, timezone)
      : getValidationDate(edit.end_time, timezone)
    : // : type === 'public'
      // ? null
      getValidationDate(new Date(), timezone);

  return {
    name: alert ? alert.subject : edit ? edit.title : '',
    description: alert ? alert.description : edit ? edit.description : '',
    start:
      edit || type === 'public'
        ? start
        : moment(end)
            .add(60, 'minutes')
            .format(moment.HTML5_FMT.DATETIME_LOCAL),
    end:
      edit || type === 'public'
        ? end
        : moment(end)
            .add(120, 'minutes')
            .format(moment.HTML5_FMT.DATETIME_LOCAL),
    send_email: edit
      ? edit.notification_options &&
        edit.notification_options.send_email == 'true'
      : false,
    send_tweet: edit
      ? edit.notification_options &&
        edit.notification_options.send_tweet == 'true'
      : false,
    backfill: false,
    privacy: edit && edit.is_private ? PRIVACY_OPTIONS[1] : PRIVACY_OPTIONS[0],
    source: edit ? edit.source_mini : defaultIncidentSource,
    affected_components: edit ? edit.affected_components : [],
    is_auto_update_status_on_start: edit
      ? edit.is_auto_update_status_on_scheduled_start
      : true,
    is_auto_update_status_on_end: edit
      ? edit.is_auto_update_status_on_scheduled_end
      : true,
    email_before_one_hour: edit
      ? edit.notification_options &&
        edit.notification_options.email_before_one_hour == 'true'
      : false,
    email_before_day_hour: edit
      ? edit.notification_options &&
        edit.notification_options.email_before_day_hour == 'true'
      : false,
    email_on_start: edit
      ? edit.notification_options &&
        edit.notification_options.email_on_start == 'true'
      : false,
    email_on_complete: edit
      ? edit.notification_options &&
        edit.notification_options.email_on_complete == 'true'
      : false
  };
};
